import styled from "styled-components";

export const StyledWrap = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;
